import SoftModel from "components/SoftModal";
import SoftButton from "components/SoftButton";
import SoftInput from "components/SoftInput";
import SoftTypography from "components/SoftTypography";
import SoftBox from "components/SoftBox";
import Icon from "@mui/material/Icon";
import { useState } from "react";
import { useAgencyInfo } from "context/agency";
import { useAppServices } from "hook/services";


const DeleteCouponModal = ({ open, onClose, refetchCoupons, setEditCoupon, editCoupon }) => {
    const [deleteText, setDeleteText] = useState('')
    const [loading, setLoadingDelete] = useState(false)
    const [agency] = useAgencyInfo()
    const services = useAppServices()

    const handleDelete = async () => {
        setLoadingDelete(true);
        try {
            const result = await services.coupons.deleteCoupon({
                query: `promo_id=${editCoupon.id}&agency_id=${agency._id}`,
                toaster: true,
            });
            refetchCoupons();
            setEditCoupon(null)
            onClose();
        } catch (error) {
            console.error("Error deleting coupon:", error);
        } finally {
            setLoadingDelete(false);
        }
    }

    return (
        <SoftModel
            open={open}
            onClose={onClose}
            width="35%"
        >
            <SoftBox>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px' }}>
                    <SoftTypography style={{ fontWeight: 'bold' }}>
                        Delete Coupon
                    </SoftTypography>
                    <Icon sx={{ cursor: "pointer" }} onClick={onClose}>close</Icon>
                </div>

                <SoftTypography style={{ fontSize: '18px' }} color="text" mb={3}>
                    Once deleted your coupon can not be restored please type
                    <span style={{ fontWeight: 'bold', color: 'black' }}> Confirm </span>
                    to delete this coupon.
                </SoftTypography>

                <SoftBox mb={3}>
                    <SoftInput
                        placeholder="Type Confirm"
                        value={deleteText}
                        onChange={(e) => setDeleteText(e.target.value)}
                        fullWidth
                    />
                </SoftBox>

                <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px' }}>
                    <SoftButton
                        variant="outlined"
                        color="black"
                        onClick={onClose}
                        fullWidth
                    >
                        Cancel
                    </SoftButton>
                    <SoftButton
                        variant="gradient"
                        color="error"
                        disabled={deleteText !== "Confirm" || loading}
                        onClick={handleDelete}
                        fullWidth
                    >
                        {loading ? 'Wait...' : "Delete"}
                    </SoftButton>
                </div>
            </SoftBox>
        </SoftModel>
    )
}
export default DeleteCouponModal;